import * as React from 'react';
import {FunctionComponent} from 'react';

interface OwnProps {}

export const Container: FunctionComponent<OwnProps> = ({children}) => {
    return <div className="container-fluid flex-grow-1">{children}</div>;
};
